import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { LearnButton } from "./LearnMoreButton.styles";

function LearnMoreButton({ link }) {
    return (
        <LearnButton variant="contained" href={`${link}`}>
            <FormattedMessage
                id="LearnMoreButton.text"
                defaultMessage="Learn more"
                description="Learn more button"
            />
        </LearnButton>
    );
}

LearnMoreButton.propTypes = {
    link: PropTypes.string.isRequired,
};

export default LearnMoreButton;
